import React from 'react';

type Props = {
  label: string;
  isActive: boolean;
  isDisabled?: boolean;
  onClick: () => void;
};
function NavMenuButton({ label, isActive, isDisabled = false, onClick }: Props) {
  return (
    <button
      disabled={isDisabled}
      className={`w-full text-left px-2 h-8 flex items-center rounded block mb-2 transition-colors ${
        isActive ? 'text-brand cursor-default bg-medium' : 'bg-light'
      } ${isDisabled ? 'text-inactive cursor-not-allowed' : 'hover:bg-medium'}`}
      onClick={onClick}
    >
      {label}
    </button>
  );
}

function NavMenuSeparator() {
  return <div className="border-t border-light mx-2 my-2" style={{ height: '1px' }} />;
}

export { NavMenuButton, NavMenuSeparator };
